// extracted by css-extract-rspack-plugin
export default {"panel":"Relations_panel__F71+s"};